export default {"src":"/_next/static/media/facebook.dd1a51f3.svg","height":31,"width":30};